import createPalette from '@mui/material/styles/createPalette';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    primaryStrong: PaletteColor;
    brand: PaletteColor;
    link: PaletteColor;
    border: Pick<PaletteColor, 'main'>;
  }
  interface PaletteOptions {
    primaryStrong?: PaletteColorOptions;
    brand?: PaletteColorOptions;
    link?: PaletteColorOptions;
    border?: PaletteColorOptions;
  }
}

declare module '@mui/material/styles' {
  interface TypeBackground {
    light: string;
    dark: string;
    info?: string;
  }
}

const palette = createPalette({
  primary: {
    light: '#E0E0E0',
    main: '#757575',
    dark: '#1E1E1E',
    contrastText: '#FFFFFF',
  },
  /**
   * Use for components where the main color is primary.dark
   */
  primaryStrong: {
    light: '#757575',
    main: '#1E1E1E',
    dark: '#000000',
    contrastText: '#FFFFFF',
  },
  secondary: {
    light: '#F3F3F3',
    main: '#C4C4C4',
    dark: '#747474',
    contrastText: '#000000',
  },
  brand: {
    light: '#E2F7F2',
    main: '#01EAD3',
    dark: '#3EDBCC',
    contrastText: '#FFFFFF',
  },
  error: {
    light: '#FEF3F2',
    main: '#F04438',
    dark: '#BC3003',
    contrastText: '#FFFFFF',
  },
  warning: {
    light: '#FFFAEB',
    main: '#F79009',
    dark: '#AC5F04',
    contrastText: '#FFFFFF',
  },
  success: {
    light: '#ECFDF3',
    main: '#12B76A',
    dark: '#207A00',
    contrastText: '#FFFFFF',
  },
  link: {
    light: '#8AD6D2',
    main: '#1F7F79',
    dark: '#1C615C',
    contrastText: '#FFFFFF',
  },
  background: {
    paper: '#FEFEFE',
    default: '#FEFEFE',
    light: '#F4F4F4',
    dark: '#000000',
    info: '#F1FBF9',
  },
  text: {
    primary: '#1E1E1E',
    secondary: '#757575',
    disabled: '#BDBDBD',
  },
  border: {
    main: '#D9D9D9',
  },
});

export default palette;
